var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon19Share(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 16.9c0 2.1 1.7 3.8 3.8 3.8s3.8-1.7 3.8-3.8-1.7-3.8-3.8-3.8-3.8 1.7-3.8 3.8zm6.1 0c0 1.3-1 2.3-2.3 2.3s-2.3-1-2.3-2.3 1-2.3 2.3-2.3 2.3 1 2.3 2.3zm-11.3.7H3.5c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h3.4c.4-5 4.6-9 9.7-9 3.7 0 7.1 2.1 8.8 5.5.2.4 0 .8-.3 1-.4.2-.8 0-1-.3-1.4-2.9-4.2-4.6-7.4-4.6-4.6 0-8.3 3.7-8.3 8.3-.1.4-.4.7-.8.7zm22.8-.7c0 .4-.3.8-.8.8h-3.4c-.4 5-4.6 9-9.7 9-3.7 0-7.1-2.1-8.8-5.5-.2-.4 0-.8.3-1 .4-.2.8 0 1 .3 1.4 2.9 4.2 4.6 7.4 4.6 4.6 0 8.3-3.7 8.3-8.3 0-.4.3-.8.8-.8h4.1c.5.1.8.5.8.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon19Share);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_19_Share.94910f9d.svg";
export { ForwardRef as ReactComponent };